import { getUploadManager } from "./uploadManagerSingleton";
import { hydrateUploads } from "./uploadSlice";
import { hydratePersistedUploads } from "../redux/slices/transferManagerSlice";
import { startUploadProgressSync } from "./uploadProgressSync";

let hydrationStarted = false;

export async function hydrateUploadTransfers({ dispatch, manager } = {}) {
  if (typeof dispatch !== "function") {
    throw new Error(
      "A Redux dispatch function is required to hydrate uploads."
    );
  }
  const uploadManager = manager || (await getUploadManager());
  const jobs = await dispatch(hydrateUploads({ manager: uploadManager }));
  dispatch(hydratePersistedUploads({ jobs }));
  return jobs;
}

export function bootstrapUploadTransfers({ store, manager } = {}) {
  if (!store || typeof store.dispatch !== "function") {
    throw new Error(
      "A Redux store with dispatch is required to bootstrap upload hydration."
    );
  }
  if (hydrationStarted) return null;
  hydrationStarted = true;

  const hydrationPromise = (async () => {
    const uploadManager = manager || (await getUploadManager());
    await hydrateUploadTransfers({
      dispatch: store.dispatch,
      manager: uploadManager
    });
    return startUploadProgressSync({ store, manager: uploadManager });
  })();
  // Upload persistence is an enhancement and must not block app rendering.
  hydrationPromise.catch(() => {});
  return hydrationPromise;
}

export function resetUploadTransferHydrationForTests() {
  hydrationStarted = false;
}
